import { whatsAppReducer } from "./whatsAppReducer";
import { whatsAppReportReducer } from "./whatsAppReportReducer";

const whatsAppReducers = {
  whatsApp: whatsAppReducer,
  whatsAppReport: whatsAppReportReducer,
};

export default whatsAppReducers;